import { render } from "./SessionView.vue?vue&type=template&id=45c93e81&scoped=true&ts=true"
import script from "./SessionView.vue?vue&type=script&lang=ts"
export * from "./SessionView.vue?vue&type=script&lang=ts"

import "./SessionView.vue?vue&type=style&index=0&id=45c93e81&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c93e81"]])

export default __exports__